import React from 'react'
import { Form, Dropdown } from 'semantic-ui-react'

const renderPages = () => {
  return [
    { value: null, text: '--' },
    { value: 'audioguide', text: 'L\'audio guide' },
    { value: 'place', text: 'Le lieu' },
    { value: 'boutiques', text: 'Les boutiques' },
    { value: 'restaurants', text: 'Les restaurants' },
    { value: 'events', text: 'Les événements' },
    { value: 'blog', text: 'Les articles du blog' },
    { value: 'offers', text: 'Les offres' },
    { value: 'hotel', text: 'L\'hotel' },
    { value: 'cig', text: 'Le CIG' },
    { value: 'enigma', text: 'Le jeu d\'énigmes' },
    { value: 'offices', text: 'Les bureaux' }
  ]
}

const details = ({obj, language, onChange}) => {
  return (
    <div>
      <Form.Field>
        <Form.Input label='Titre' placeholder="Titre" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Form.Group widths='equal'>
        <Form.Input placeholder='Label du bouton' id='cta_label' fluid label='Label du bouton' value={obj.translations[language.code].cta_label} onChange={(e) => onChange(e, language.code)} />
        <Form.Field>
          <label htmlFor='cta_url'>Page cible</label>
          <Dropdown placeholder='Sélectionnez une page' fluid selection closeOnChange id='cta_url' value={obj.translations[language.code].cta_url} options={renderPages()} onChange={(e, data) => onChange(e, { code: language.code, id: data.id, value: data.value }, 'dropdown')} />
        </Form.Field>
      </Form.Group>
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/homeApp/details.js